module.exports = __webpack_public_path__ + "static/media/halo-clean-mobile.f9594b43.svg";